import { useState, useEffect, useCallback } from 'react';
import { doc, onSnapshot, setDoc, serverTimestamp } from 'firebase/firestore';
import { db, appId } from '../config/firebase';

const DEFAULTS = {
  analysisCacheTTLDays: 30,
  comparisonCacheTTLDays: 30,
};

export const useCacheConfig = () => {
  const [cacheConfig, setCacheConfig] = useState(DEFAULTS);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!db) {
      setIsLoading(false);
      return;
    }

    const configRef = doc(db, `artifacts/${appId}/appSettings/cacheConfig`);

    const unsubscribe = onSnapshot(
      configRef,
      (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          setCacheConfig({
            analysisCacheTTLDays: data.analysisCacheTTLDays ?? DEFAULTS.analysisCacheTTLDays,
            comparisonCacheTTLDays: data.comparisonCacheTTLDays ?? DEFAULTS.comparisonCacheTTLDays,
          });
        } else {
          setCacheConfig(DEFAULTS);
        }
        setIsLoading(false);
      },
      (err) => {
        console.error('Error fetching cache config:', err);
        setCacheConfig(DEFAULTS);
        setIsLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  const updateCacheConfig = useCallback(async (newConfig, userId) => {
    if (!db) throw new Error('Database not available');

    const configRef = doc(db, `artifacts/${appId}/appSettings/cacheConfig`);
    await setDoc(configRef, {
      analysisCacheTTLDays: newConfig.analysisCacheTTLDays,
      comparisonCacheTTLDays: newConfig.comparisonCacheTTLDays,
      updatedAt: serverTimestamp(),
      updatedBy: userId,
    });
  }, []);

  return { cacheConfig, isLoading, updateCacheConfig };
};
